// "Same as Primary Contact" toggle for the Accounts / Executive contact blocks.
// On: copies each Primary Contact field into the matching field of the toggled
// group. Off: clears that group's fields. Mirrors address_copy_controller so the
// two "same as" controls behave identically. Fields are matched by
// data-contact-field; the group is data-contact-group.
import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['field']

  toggle(event) {
    const group = event.currentTarget.dataset.contactGroup
    if (event.target.checked) {
      this.copy(group)
    } else {
      this.clear(group)
    }
  }

  copy(group) {
    this.fieldsFor(group).forEach((destination) => {
      const source = this.primaryFieldFor(destination.dataset.contactField)
      if (source) destination.value = source.value
    })
  }

  clear(group) {
    this.fieldsFor(group).forEach((destination) => {
      destination.value = ''
    })
  }

  fieldsFor(group) {
    return this.fieldTargets.filter(
      (field) => field.dataset.contactGroup === group
    )
  }

  primaryFieldFor(fieldName) {
    return this.fieldTargets.find(
      (field) =>
        field.dataset.contactGroup === 'primary' &&
        field.dataset.contactField === fieldName
    )
  }
}
